'use client';

import { useTranslations } from 'next-intl';
import toast, { resolveValue, Toaster, ToastType } from 'react-hot-toast';
import {
  TbCircleCheck,
  TbExclamationCircle,
  TbInfoCircle,
  TbX,
} from 'react-icons/tb';

const typeToDaisy = (type: ToastType) => {
  switch (type) {
    case 'success':
      return 'alert-success';
    case 'error':
      return 'alert-error';
    default:
      return '';
  }
};

const typeToIcon = (type: ToastType) => {
  switch (type) {
    case 'loading':
      return <span className="loading loading-spinner loading-md h-8"></span>;
    case 'success':
      return <TbCircleCheck size={24} className="min-h-8" />;
    case 'error':
      return <TbExclamationCircle size={24} className="min-h-8" />;
    default:
      return <TbInfoCircle size={24} className="min-h-8" />;
  }
};

export const ToastWrapper = () => {
  const t = useTranslations('Toaster');
  return (
    <Toaster
      position="top-right"
      toastOptions={{ success: { duration: 10000 } }}
    >
      {(bread) => {
        const animation = bread.visible
          ? 'animate-toast-enter'
          : 'animate-toast-exit';
        return (
          <div
            className={`alert max-w-md min-w-sm ${typeToDaisy(bread.type)} ${animation}`}
          >
            {/* h-8 is equivalent to btn-sm */}
            {bread.icon && (
              <span className="min-h-8">resolveValue(bread.icon, bread)</span>
            )}
            {!bread.icon && typeToIcon(bread.type)}
            <span>{resolveValue(bread.message, bread)}</span>
            {bread.type !== 'loading' && (
              <div className="tooltip" data-tip={t('dismiss')}>
                <button
                  className="btn btn-ghost btn-sm"
                  onClick={() => toast.dismiss(bread.id)}
                  aria-label={t('dismiss')}
                >
                  <TbX />
                </button>
              </div>
            )}
          </div>
        );
      }}
    </Toaster>
  );
};
